import type {ReactNode} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import {SheetActions} from '../SheetActions';

type DiscardCopy = {
  title?: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
};

type DiscardChangesDialogProps = {
  open: boolean;
  copy?: DiscardCopy;
  onConfirm: () => void;
  onCancel: () => void;
};

function DiscardChangesDialog({
  open,
  copy,
  onConfirm,
  onCancel,
}: DiscardChangesDialogProps) {
  const {t} = useTranslation();

  return (
    <ResponsiveSheet
      open={open}
      onClose={onCancel}
      title={copy?.title ?? t('discard_data')}
      className="discard-changes-modal"
      dialogClassName="!max-w-[460px]"
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
    >
      <div className="flex flex-col gap-8">
        <p className="text-sm text-[var(--chekin-text-secondary)]">
          {copy?.description ?? (
            <Trans i18nKey="discard_data_leaving_the_process">
              Leaving the process before completing the registration will
              <b>discard your personal data</b> so you will have to complete the from
              again.
            </Trans>
          )}
        </p>
        <SheetActions>
          <Button onClick={onConfirm}>
            {copy?.confirmLabel ?? t('discard_changes_leaving')}
          </Button>
          <Button variant="link" onClick={onCancel}>
            {copy?.cancelLabel ?? t('continue_process')}
          </Button>
        </SheetActions>
      </div>
    </ResponsiveSheet>
  );
}

export {DiscardChangesDialog};
export type {DiscardCopy};
